import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { AlertService } from "src/app/services/alert.service";
import { CashBookingService } from "src/app/services/cashbooking.service";
import { DivisionService } from "src/app/services/division.service";
import { DriverService } from "src/app/services/driver.service";
import { ExcelService } from "src/app/services/excel.service";
import { PaccsbookingService } from "src/app/services/paccsbooking.service";
import { RegionService } from "src/app/services/region.service";
import { ServiceproviderService } from "src/app/services/serviceprovider.service";
import { SubDivisionService } from "src/app/services/subdivision.service";
import { UserSessionService } from "src/app/services/usersession.service";
import { RoleType } from "src/enum/roletype";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";
import { HttpClient } from "@angular/common/http";
import { AdministrativeMappingService } from "src/app/services/administrative-mapping.service";


@Component({
  selector: "app-paccsduplicate",
  templateUrl: "./paccsduplicate.component.html",
  styleUrls: ["./paccsduplicate.component.scss"],
})
export class PaccsduplicateComponent implements OnInit {
  form: FormGroup;
  roleId: any;
  public RoleEnumType = RoleType;
  districtList: any[];
  filterListdistrict: any[];
  districtId: any;
  blockList: any[];
  filterListblock: any[];
  blockId: number;
  blockIdDisabled: boolean;
  districtDisabled: boolean;
  serviceProviderList: any[] = [];
  dataSource = new MatTableDataSource(this.serviceProviderList);
  currentItemsToShow: any[];
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  loader: boolean = false;
  public imageBaseUrl = environment.imageBaseUrl;
  imageUrl: string;
  blockId1: any;
  serviceProviderAllList: any;
  Data: any;
  @Input() isDrilldown: boolean;
  @Input() districtData: any;
  @Input() storeddistrictData: any;
  @ViewChild("searchInput", { static: true }) searchInput: ElementRef;
  serviceProviderTypeList: any[] = [];
  filterProviderTypeList: any[] = [];
  statusList: any[];
  filterstatusList: any[];
  eventTypeName: any;
  excelColumns: string[];
  serviceProviderObj: any;

  divisionId: any;
  subdivisionId: any;
  filterdivisionList: any[];
  subdivisionList: any[];
  filtersubdivision: any[];
  regionList: any[] = [];
  filterregionList: any[] = [];
  regionId: any;
  Blocklist: any[];
  filterBlocklist: any[];
  regionId1: any;
  divisionId1: any;
  subdivisionId1: any;
  divisionList: any[];
  duplicate: boolean = true;
   financialYearList: any[] = [];
  filterFinancialYearList: any[] = [];
  selectedFinYearId: any;

  constructor(
    private formBuilder: FormBuilder,
    private paccsBookingService: PaccsbookingService,
    private cashBookingService: CashBookingService,
    private router: Router,
    private userSessionService: UserSessionService,
    private spService: ServiceproviderService,
    private excelService: ExcelService,
    private alertService: AlertService,
    private regionService: RegionService,
    private divisionService: DivisionService,
    private subDivisionService: SubDivisionService,
    private driverService: DriverService,
    private serviceProviderService: ServiceproviderService,
    private http: HttpClient,
     private administrativeMappingService: AdministrativeMappingService,
  ) {
    this.roleId = this.userSessionService.roleId();
    this.regionId = JSON.parse(this.userSessionService.getRegionId());
    this.regionId1 = JSON.parse(this.userSessionService.getRegionId());
    this.divisionId = JSON.parse(this.userSessionService.getDivisionId());
    this.divisionId1 = JSON.parse(this.userSessionService.getDivisionId());
    this.subdivisionId = JSON.parse(this.userSessionService.getSubDivisionId());
    this.subdivisionId1 = JSON.parse(
      this.userSessionService.getSubDivisionId(),
    );
    this.blockId = JSON.parse(this.userSessionService.getUserBlockId());
    this.blockId1 = JSON.parse(this.userSessionService.getUserBlockId());
  }

  ngOnInit(): void {
    this.districtId = parseInt(this.userSessionService.getUserdistrictId());
    this.blockId = parseInt(this.userSessionService.getUserBlockId());

    this.roleId = this.userSessionService.roleId();
    this.initializeValidators();
     this.getfinancialyear(true);
    this.serviceProviderType();

    // if (
    //   this.roleId == this.RoleEnumType.JR ||
    //   this.roleId == this.RoleEnumType.RCS ||
    //   this.roleId == this.RoleEnumType.PAACS ||
    //   this.roleId == this.RoleEnumType.FOCSR
    // ) {
    //   this.getDistrict();
    // } else {
    //   this.getLookupRegion();
    // }

    this.statusList = [
      { key: 0, value: "All" },
      { key: 1, value: "UnPaid" },
      { key: 2, value: "Paid" },
      { key: 3, value: "Mark as Duplicate" },
    ];
    this.filterstatusList = this.statusList.slice();
    this.serviceProviderObj = {
      roleType: this.roleId,
    };
    this.form.get("status")?.disable();
  }
  initializeValidators() {
    this.form = this.formBuilder.group({
      regionid: [0],
      divisionId: [0],
      subdivisionId: [0],
      districtId: [0],
      blockId: [0],
      projectId: [2],
      status: [3],
      financialYearId: [0]
    });
  }

   getfinancialyear(refresh: boolean) {

    this.regionService.getFinYear(refresh).subscribe(result => {

      if (result) {

        this.financialYearList = result;

        this.filterFinancialYearList = [];

        this.filterFinancialYearList.push({
          key: 0,
          value: "All",
          startYear: 0,
          endYear: 0
        });

        this.financialYearList.forEach(element => {
          this.filterFinancialYearList.push(element);
        });

        const today = new Date();

        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth() + 1;

        let selectedYear: any;

        // April to March FY
        if (currentMonth >= 4) {

          selectedYear = this.financialYearList.find(x =>
            Number(x.startYear) === currentYear &&
            Number(x.endYear) === currentYear + 1
          );

        } else {

          selectedYear = this.financialYearList.find(x =>
            Number(x.startYear) === currentYear - 1 &&
            Number(x.endYear) === currentYear
          );

        }

           if (!selectedYear && this.financialYearList.length > 0) {
        selectedYear = this.financialYearList[this.financialYearList.length - 1];
      }

        // Patch current FY
        if (selectedYear) {

          this.selectedFinYearId = selectedYear.key;

          this.form.controls['financialYearId']
            .setValue(selectedYear.key);

        }

        if (
          this.roleId == this.RoleEnumType.JR ||
          this.roleId == this.RoleEnumType.RCS ||
          this.roleId == this.RoleEnumType.PAACS ||
          this.roleId == this.RoleEnumType.FOCSR
        ) {
          this.getDistrict();
        } else {
          this.getLookupRegion();
        }
      }
    });
  }
  financialYearChange() {

    this.selectedFinYearId =
      this.form.value.financialYearId;

    this.form.controls["regionid"].setValue(0);
    this.form.controls["divisionId"].setValue(0);
    this.form.controls["subdivisionId"].setValue(0);

    this.regionId = 0;
    this.divisionId = 0;
    this.subdivisionId = 0;

    if (
      this.roleId == this.RoleEnumType.JR ||
      this.roleId == this.RoleEnumType.RCS ||
      this.roleId == this.RoleEnumType.PAACS ||
      this.roleId == this.RoleEnumType.FOCSR
    ) {
      this.getDistrict();
    } else {
      this.getLookupRegion();
    }
  }
  refresh() {
    this.subdivisionList = [];
    this.filtersubdivision = [];
    this.divisionList = [];
    this.filterdivisionList = [];
    this.Blocklist = [];
    this.filterBlocklist = [];
    this.form.controls["regionid"].setValue(0);
    this.form.controls["divisionId"].setValue(0);
    this.form.controls["subdivisionId"].setValue(0);
    this.form.controls["blockId"].setValue(0);
    this.form.controls["projectId"].setValue(2);
    this.form.controls["status"].setValue(0);
    this.initializeValidators();
     this.getfinancialyear(true);

    if (
      this.roleId == this.RoleEnumType.JR ||
      this.roleId == this.RoleEnumType.RCS ||
      this.roleId == this.RoleEnumType.PAACS ||
      this.roleId == this.RoleEnumType.FOCSR
    ) {
      this.getDistrict();
    } else {
      this.getLookupRegion();
    }
    this.searchInput.nativeElement.value = "";
  }
  getblock() {
    this.form.controls["blockId"].setValue(0);

    let blockLookup;

    blockLookup = this.cashBookingService.blockLookUp(
      this.form.value.districtId,
      1,
      true,
    );

    blockLookup.subscribe((res) => {
      this.blockList = [];
      this.filterListblock = [];
      this.blockList = res;
      this.filterListblock = this.blockList.slice();
      let blocklist = [];
      blocklist = res;

      const districtLength = blocklist.length;
      if (districtLength === 1 && this.storeddistrictData?.blockId == 0) {
        this.form.controls["blockId"].setValue(blocklist[0].key);
      }
      if (this.blockId && !this.isDrilldown) {
        this.form.controls["blockId"].setValue(this.blockId);
        this.blockIdDisabled = true;
      }
      if (
        this.storeddistrictData?.blockId > 0 ||
        this.districtData?.blockId > 0
      ) {
        this.form.controls["blockId"].setValue(
          this.storeddistrictData?.blockId
            ? this.storeddistrictData?.blockId
            : this.districtData?.blockId
              ? this.districtData?.blockId
              : 0,
        );
        this.blockIdDisabled = true;
      }
      if (this.roleId != this.RoleEnumType.PAACS) {
        this.getServiceProvider();
      }
    });
  }
  getDistrict() {
    let districtLookup;

    districtLookup = this.cashBookingService.districtData(1, true);

    districtLookup.subscribe((result) => {
      if (result) {
        this.districtList = [];
        this.filterListdistrict = [];
        this.districtList = result;
        this.filterListdistrict = this.districtList.slice();
        const districtLength = this.districtList.length;
        if (districtLength === 1) {
          this.form.controls["districtId"].setValue(this.districtList[0].key);
          this.districtDisabled = true;
          this.getblock();
        }

        if (this.districtId && !this.isDrilldown) {
          this.form.controls["districtId"].setValue(this.districtId);
          this.districtDisabled = true;
          this.getblock();
        }
        if (this.storeddistrictData?.id > 0 || this.districtData?.id > 0) {
          this.form.controls["districtId"].setValue(
            this.storeddistrictData?.id
              ? this.storeddistrictData?.id
              : this.districtData?.id
                ? this.districtData?.id
                : 0,
          );
          this.districtDisabled = true;
          this.getblock();
        }
        if (this.roleId != this.RoleEnumType.PAACS && !this.districtId) {
          this.getServiceProvider();
        }
      }
    });
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.dataSource.paginator = this.paginator;
    this.currentItemsToShow = this.dataSource.filteredData;
    this.onPageChange({
      previousPageIndex: 0,
      pageIndex: 0,
      pageSize: 10,
      length: this.currentItemsToShow.length,
    });
  }
  onPageChange($event) {
    this.currentItemsToShow = this.dataSource.filteredData.slice(
      $event.pageIndex * $event.pageSize,
      $event.pageIndex * $event.pageSize + $event.pageSize,
    );
  }

  getLookupRegion() {
    this.regionList = [];
    this.filterregionList = [];
    //this.regionService.getLookUp(true).subscribe((result) => {
     const refDate = this.form.value.financialYearId ?? 0 ;
    this.administrativeMappingService.getRegions(refDate, true).subscribe(result => {
      if (result) {
        this.regionList = [];
        this.filterregionList = [];
        this.regionList = result;
        this.filterregionList = this.regionList.slice();
        if (this.regionId > 0) {
          this.form.controls["regionid"].setValue(this.regionId);
          this.getLookupDivision(this.regionId);
        } else {
          this.getPaccsServiceProvider();
        }
      }
    });
  }

  regionChange() {
    // this.regionId = this.form.value.regionid;
    this.getLookupDivision(this.form.value.regionid);
    this.divisionId = 0;
    this.subdivisionId = 0;
    this.blockId = 0;
    this.subdivisionList = [];
    this.filtersubdivision = [];
    this.Blocklist = [];
    this.filterBlocklist = [];
    this.form.controls["divisionId"].setValue(0);
    this.form.controls["subdivisionId"].setValue(0);
    this.form.controls["blockId"].setValue(0);
    this.onPageChange({
      previousPageIndex: 0,
      pageIndex: 0,
      pageSize: 10,
      length: this.serviceProviderList.length,
    });
  }

  getLookupDivision(id) {
    this.divisionList = [];
    this.filterdivisionList = [];
   // this.divisionService.getLookUpbyId(true, id).subscribe((result) => {
    const refDate = this.form.value.financialYearId ?? 0 ;
    this.administrativeMappingService.getDivisions(id, refDate, true).subscribe(result => {
      if (result) {
        this.divisionList = [];
        this.filterdivisionList = [];
        this.divisionList = result;
        this.filterdivisionList = this.divisionList.slice();
        if (this.divisionId > 0) {
          this.form.controls["divisionId"].setValue(this.divisionId);
          this.getLookupSubDivision(this.divisionId);
        } else {
          this.getPaccsServiceProvider();
        }
      }
    });
  }

  divisionChange() {
    debugger;
    // this.divisionId = this.form.value.divisionId;
    this.getLookupSubDivision(this.form.value.divisionId);
    this.subdivisionId = 0;
    this.blockId = 0;
    this.Blocklist = [];
    this.filterBlocklist = [];
    this.form.controls["subdivisionId"].setValue(0);
    this.form.controls["blockId"].setValue(0);
    this.onPageChange({
      previousPageIndex: 0,
      pageIndex: 0,
      pageSize: 10,
      length: this.serviceProviderList.length,
    });
  }

  getLookupSubDivision(id) {
    this.subdivisionList = [];
    this.filtersubdivision = [];
    //this.subDivisionService.getLookUpbyId(true, id).subscribe((result) => {
    const refDate = this.form.value.financialYearId ?? 0 ;
    this.administrativeMappingService.getSubDivisions(id, refDate, true).subscribe(result => {
      if (result) {
        this.subdivisionList = [];
        this.filtersubdivision = [];
        this.subdivisionList = result;
        this.filtersubdivision = this.subdivisionList.slice();
        if (this.subdivisionId > 0) {
          this.form.controls["subdivisionId"].setValue(this.subdivisionId);
          this.getblocklist(this.subdivisionId);
        } else {
          this.getPaccsServiceProvider();
        }
      }
    });
  }

  subdivisionChange() {
    // this.subdivisionId = this.form.value.subdivisionId;
    this.getblocklist(this.form.value.subdivisionId);
    this.form.controls["blockId"].setValue(0);
    this.onPageChange({
      previousPageIndex: 0,
      pageIndex: 0,
      pageSize: 10,
      length: this.serviceProviderList.length,
    });
  }

  getblocklist(id) {
    this.Blocklist = [];
    this.filterBlocklist = [];
    this.driverService.getBlocklist(id, true).subscribe((res) => {
      if (res) {
        this.Blocklist = [];
        this.filterBlocklist = [];
        this.Blocklist = res;
        this.filterBlocklist = this.Blocklist.slice();
        if (this.blockId > 0) {
          this.form.controls["blockId"].setValue(this.blockId);
        }
        this.getPaccsServiceProvider();
      }
    });
  }

  getPaccsServiceProvider() {
    this.loader = true;
    this.duplicate = true;
    debugger;
    this.spService
      .getpaacsduplicatedata(
        this.form.value.regionid,
        this.form.value.divisionId,
        this.form.value.subdivisionId,
        this.form.value.districtId,
        this.form.value.blockId,
        this.form.value.projectId,
        this.duplicate,
         this.form.value.financialYearId,

      )
      .subscribe((res: any) => {
        if (res) {
          this.serviceProviderList = res;
          this.serviceProviderAllList = res;
          this.Data = res;
          this.dataSource = new MatTableDataSource(this.serviceProviderList);
          this.currentItemsToShow = this.serviceProviderList;
          this.dataSource.paginator = this.paginator;
          this.onPageChange({
            previousPageIndex: 0,
            pageIndex: 0,
            pageSize: 10,
            length: this.serviceProviderList.length,
          });
        }
        if (this.form.value.status > 0) {
          this.statusChange();
        }
        this.loader = false;
      });
  }

  downloadPdf(path: any) {
    this.imageUrl = this.imageBaseUrl + "SPTermsEsign/" + path;

    var url = this.imageUrl;
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const downloadLink = document.createElement("a");
        downloadLink.href = blobUrl;
        downloadLink.download =
          "Service Provider Terms & Conditions e-Signed Copy";

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        window.URL.revokeObjectURL(blobUrl);
      })
      .catch((error) => {
        console.error("Error downloading the document:", error);
      });
  }

  getServiceProvider() {
    this.loader = true;
    this.duplicate = true;
    this.spService
      .getpaacsduplicatedata(
        0,
        0,
        0,
        this.form.value.districtId,

        this.form.value.blockId,
        this.form.value.projectId,
        this.duplicate,
         this.form.value.financialYearId, 
      
      )
      .subscribe((res: any) => {
        if (res) {
          this.serviceProviderList = res;
          this.serviceProviderAllList = res;
          this.Data = res;
          this.dataSource = new MatTableDataSource(this.serviceProviderList);
          this.currentItemsToShow = this.serviceProviderList;
          this.dataSource.paginator = this.paginator;
          this.onPageChange({
            previousPageIndex: 0,
            pageIndex: 0,
            pageSize: 10,
            length: this.serviceProviderList.length,
          });
        }
        if (this.form.value.status > 0) {
          this.statusChange();
        }
        this.loader = false;
      });
  }

  sptypeChange() {
    this.onPageChange({
      previousPageIndex: 0,
      pageIndex: 0,
      pageSize: 10,
      length: this.serviceProviderList.length,
    });
    this.getServiceProvider();
  }
  statusChange() {
    this.searchInput.nativeElement.value = "";
    if (this.form.value.status == 0) {
      this.Data = this.serviceProviderAllList;
    } else {
      this.Data = this.serviceProviderAllList.filter(
        (x) => x.spStatusType == this.form.value.status,
      );
    }
    this.dataSource = new MatTableDataSource(this.Data);
    this.currentItemsToShow = this.Data;
    if (this.paginator) {
      this.paginator.firstPage();
    }
    this.dataSource.paginator = this.paginator;
    this.onPageChange({
      previousPageIndex: 0,
      pageIndex: 0,
      pageSize: this.paginator.pageSize || 10,
      length: this.Data.length,
    });
  }
  serviceProviderType() {
    this.serviceProviderTypeList = [
      { key: 0, value: "All" },
      { key: 1, value: "Private" },
      { key: 2, value: "PACCS" },
    ];

    this.filterProviderTypeList = this.serviceProviderTypeList;
  }
  blockChange() {
    this.getServiceProvider();
  }
  exportAsXLSX(): void {
    var exportData = this.serviceProviderList;
    if (!exportData || exportData.length === 0) {
      this.alertService.info("No data available to export");
      return;
    }
    this.excelColumns = [
      "S.no",
      "PACCS Name",
      "Mobile No",
      "Tan No",
      "District Name",
      "Taluk Name",
      "Block Name",
      "Grampanchayat Name",
      "Address",
      "Pincode",
      "Machinary Count",
      "Implement Count",
      "Total",
      "Machinary Name",
      "Implement Name",
    ];
    const excelList = [];
    exportData.forEach((a, index) => {
      let event;
      this.eventTypeName = event;
      excelList.push({
        sno: ++index,
        "PACCS Name": a.name,
        "Mobile No": a.mobileNo,
        "Tan No": a.panNo,
        "District Name": a.districtName,
        "Taluk Name": a.talukName,
        "Block Name": a.blockName,
        "Grampanchayat Name": a.grampanchayatName,
        Address: a.address,
        Pincode: a.pincode,
        "Machinary Count": a.totalMachinary,
        "Implement Count": a.totalImplement,
        Total: a.totalMachinary + a.totalImplement,
        "Machinary Name": a.vehicleCategoryName,
        "Implement Name": a.implementCategoryName,
      });
    });
    this.excelService.exportAsExcelFile(
      excelList,
      "PACCS Service Provider Details",
      this.excelColumns,
    );
  }

  initiatePaymentRefund(item: any) {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to initiate payment refund?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#28a745",
    }).then((result) => {
      if (result.isConfirmed) {
        const data = {
          paymentId: item.paymentRefNo,
          amount: item.amount,
        };

        this.serviceProviderService.getRefundPayment(data).subscribe({
          next: (res: any) => {
            if (res.isSuccess) {
              Swal.fire({
                title: "Success!",
                text: "Payment Refund Initiated Successfully.",
                icon: "success",
                confirmButtonColor: "#28a745",
              });
              this.getPaccsServiceProvider();
            } else {
               this.alertService.error(res.htmlFormattedFailures)
            }
            // this.getPaccsServiceProvider();
          },
        });
      }
    });
  }

  viewRefundedDetails(item: any) {
    localStorage.setItem('serviceProviderDetails', JSON.stringify(item));
    localStorage.setItem('backRoute', '1');
    this.router.navigate(['paccsserviceprovider/view']);
  }
}
